import { Component, input } from '@angular/core';
import { MaterialModule } from '../../common/material/material.module';
import { DienstleistungsartSnapshotList } from '../../domain/model/dienstleistungsart-snapshot.model';

@Component({
    selector: 'redispatch-dashboard-dienstleistungsarten',
    imports: [
        MaterialModule,
    ],
    templateUrl: './dashboard-dienstleistungsarten.component.html',
    styleUrl: './dashboard-dienstleistungsarten.component.scss',
})
export class DashboardDienstleistungsartenComponent {
    dienstleistungsarten = input<DienstleistungsartSnapshotList>([]);

    displayedColumns: string[] = [
        'diebstleistungsartName',
        'countStadtwerke',
    ];

    tooltipText = 'Diese Tabelle gibt Auskunft darüber, welche und wie viele Dienstleistungsverhältnisse aktuell mit den nVNBs bestehen.';
}
